import Immutable from 'immutable';

export const setNewMemo = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.orderId, 'accountMemos', 'newMemo'
    ], action.memo);

};
export const addMemoFinished = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.orderId, 'accountMemos', 'newMemo'
    ], '').setIn([
        'workOrderDetails', action.orderId, 'accountMemos', 'loading'
    ], false).setIn([
        'workOrderDetails', action.orderId, 'accountMemos', 'details', 'getMemoItem'
    ], state.getIn(['workOrderDetails', action.orderId, 'accountMemos', 'details', 'getMemoItem']).insert(0, Immutable.fromJS({
        commentEnterDate: action.date, 
        commentTransactionSeq: -1, 
        commentLine: action.request.memo, 
        userId: action.request.externalUserName
    })));

};
export const addMemoStarted = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.orderId, 'accountMemos', 'loading'
    ], true).setIn([
        'workOrderDetails', action.orderId, 'accountMemos', 'addMemoError'
    ], null);

};
export const addMemoFailed = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.orderId, 'accountMemos', 'loading'
    ], false).setIn([
        'workOrderDetails', action.orderId, 'accountMemos', 'addMemoError'
    ], 'Adding comment failed. Please try again.');
};


// WEBPACK FOOTER //
// ./src/reducers/work-order/memo.js